/**
 * GTM (Google Tag Manager) configuration for all modules
 * This object maps module names to their GTM tracking configurations
 */
export const GTM = {
  cart: {
    modulePath: 'checkout/cart',
    pageCategory: '',
    applicationPageName: 'cart'
  },
  cms: {
    modulePath: 'cms/page/view',
    pageCategory: '',
    applicationPageName: 'cms'
  },
  category: {
    modulePath: 'catalog/category/list',
    pageCategory: '',
    applicationPageName: 'category'
  },
  search: {
    modulePath: 'search/index/index',
    pageCategory: '',
    applicationPageName: 'category'
  },
  pdp: {
    modulePath: 'catalog/product/view',
    pageCategory: '',
    pdpCategory: 'fe-app-pdp',
    applicationPageName: 'pdp'
  },
  opc: {
    modulePath: 'opc/index',
    pageCategory: '',
    applicationPageName: 'opc'
  },
  wishlist: {
    modulePath: 'wishlist/index',
    pageCategory: '',
    applicationPageName: 'wishlist'
  },
  home: {
    modulePath: 'cms/page/view',
    pageCategory: '',
    applicationPageName: 'cms',
    homepage: true
  },
  checkout_success: {
    modulePath: 'checkout/v2/success',
    pageCategory: '',
    applicationPageName: 'success'
  },
  manufacturer: {
    modulePath: 'catalog/manufacturer/view',
    pageCategory: '',
    applicationPageName: 'manufacturer'
  },
  winery_a_z: {
    modulePath: 'winery-a-z',
    pageCategory: '',
    applicationPageName: 'winery_a_z'
  },
  account_default: {
    modulePath: 'account/manage/v2',
    pageCategory: '',
    applicationPageName: 'account'
  },
  account_action: {
    modulePath: 'account/manage/v2',
    pageCategory: '',
    applicationPageName: 'account'
  }
}

/**
 * Get GTM configuration for a specific module
 * @param {string} moduleName - The name of the module
 * @returns {Object|undefined} The GTM configuration for the module
 */
export const getGtmConfig = (moduleName) => {
  return GTM[moduleName]
}

/**
 * Check if a module has GTM configuration
 * @param {string} moduleName - The name of the module
 * @returns {boolean} True if the module has GTM configuration
 */
export const hasGtmConfig = (moduleName) => {
  return moduleName in GTM
}

/**
 * Get all module names that have GTM configuration
 * @returns {string[]} Array of module names with GTM configuration
 */
export const getGtmModuleNames = () => {
  return Object.keys(GTM)
}
